import { anyItemsInBothArrays } from '@akin-home/arrays';
import { CognitoUserGroup } from '@akin-home/aws-cognito';
import { CognitoUser } from '@aws-amplify/auth';

/** Returns whether the user is in the specified group */
export const cognitoUserInGroup =
  (group: CognitoUserGroup) => (user?: CognitoUser) =>
    !!user && getSecurityGroupsFromCognitoUser(user).includes(group);

/** Returns whether the user is in any of the specified security groups */
export const cognitoUserInAnyGroup =
  (groups: CognitoUserGroup[]) => (user?: CognitoUser) => {
    if (!user) return false;

    return anyItemsInBothArrays(getSecurityGroupsFromCognitoUser(user), groups);
  };

export const checkIsAdminUser = cognitoUserInGroup(CognitoUserGroup.ADMIN);

export const getSecurityGroupsFromCognitoUser = (user: CognitoUser): string[] =>
  user.getSignInUserSession()?.getAccessToken().payload['cognito:groups'];
